import { Route } from '@angular/router';

export const referralSourceChannelRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./referral-source-channel-list.component').then(
        (m) => m.ReferralSourceChannelListComponent
      ),
  },
  {
    path: 'add',
    loadComponent: () =>
      import('./detail/referral-source-channel-detail.component').then(
        (m) => m.ReferralSourceChannelDetailComponent
      ),
  },
  {
    path: 'edit/:id',
    loadComponent: () =>
      import('./detail/referral-source-channel-detail.component').then(
        (m) => m.ReferralSourceChannelDetailComponent
      ),
  },
];
